import { Component, Inject, Injectable, OnInit } from '@angular/core';
import { MatSnackBar, MAT_SNACK_BAR_DATA } from "@angular/material/snack-bar";

@Component({
  selector: 'app-snack-bar',
  templateUrl: './snack-bar.component.html',
  styleUrls: ['./snack-bar.component.scss'],
})
@Injectable({
  providedIn: 'root'
})

export class SnackBarComponent {
  constructor(private ref: MatSnackBar) { }

  openSnackBar(message: string, action: string, duration?: number) {
    this.ref.open(message, action, {
      panelClass: ["custom-class"],
      duration: 20000000,
      verticalPosition: "top",
    });

    if (duration) {
      setTimeout(() => this.closeSnackBar(), duration);
    }
  }

  closeSnackBar(): void {
    this.ref.dismiss()
  }

  errorSnackBar(message: string) {
    this.ref.open(message, undefined, {
      panelClass: ["error-snackbar"],
      duration: undefined,
      verticalPosition: "top",
    });
  }
}
